import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined } from "@mui/icons-material";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import FormationForm from "./forms/FormationForm";
import { CVService } from "../../../../service/CVService";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";

const Formations = () => {
  const [formations, setFormations] = useState([]);
  const [formDialogOpen, setFormDialogOpen] = useState(false);
  const [selectedFormation, setSelectedFormation] = useState({});
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const query = useQuery();
  const id_identite = query.get("id_identite");
  const handleCloseEducationForn = () => {
    setFormDialogOpen(false);
    handleFetchFormations();
  };

  const confirmDelete = (data) => {
    CVService.deleteFormation(data.formation_id).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchFormations();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteFormation = (education) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(education)
    );
  };

  const handleEditFormation = (formation) => {
    setSelectedFormation(formation);
    setFormDialogOpen(true);
  };

  const handleOpenEducationFormDialog = (education) => {
    setFormDialogOpen(true);
    setSelectedFormation({});
  };

  const handleFetchFormations = () => {
    CVService.getFormationList({
      id_identite: id_identite,
    }).then((res) => {
      if (res && res.data) {
        setFormations(res.data);
      }
    });
  };

  useEffect(() => {
    handleFetchFormations();
  }, []);
  return (
    <>
      <Toast />
      <DialogComponent />
      <FormationForm
        open={formDialogOpen}
        onFormClose={handleCloseEducationForn}
        idFormation={selectedFormation.formation_id}
      />
      <Paper>
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Formations"
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  variant={"outlined"}
                  onClick={handleOpenEducationFormDialog}
                />
              </Grid>
            }
          />
          {formations.length > 0 ? (
            formations.map((item, index) => (
              <Grid key={index}>
                <ul key={index}>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <li style={{ fontSize: "20px" }}>
                          {`${item.domaine}`}
                        </li>
                      </Stack>
                    }
                    subheader={
                      <Grid>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <CalendarMonthOutlined />
                          <span>{`Periode :  ${item.jour.padStart(2, "0")}/${item.mois.padStart(2, "0")}/${item.annee} - ${item.jour1.padStart(2, "0")}/${item.mois1.padStart(2, "0")}/${item.annee1}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <TopicOutlinedIcon />
                          <span>{`Theme de la formation : ${item.theme || ""}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <WorkspacePremiumOutlinedIcon />
                          <span>{`Attestation : ${item.certificat || ""}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <WorkspacePremiumOutlinedIcon />
                          <span>{`FID : ${item.fid || ""}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <WorkspacePremiumOutlinedIcon />
                          <span>{`Autre : ${item.autres || ""}`}</span>
                        </Stack>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) => handleEditFormation(item)}
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      text={"Supprimer"}
                      onClick={e=>handleDeleteFormation(item)}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default Formations;
